(function () {
    'use strict';

    /**
     * 
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .service('MissingSignInService', MissingSignInService);

    function MissingSignInService(MissingSignInFactory,RemoteService) {
        var self = this;

        var model={
            searchCriteria: MissingSignInFactory.getSearchRequest(),
            missingSignInList:[],
            missingSignOutList:[],
            isElasticLoadingVisible:false
        };
        
        
        self.setSearchCriteria = function (data) {
            var search = MissingSignInFactory.getSearchRequest();
            search.toDate = data.toDate;
            search.fromDate = data.fromDate;
            search.crewType = data.crewType !== null && data.crewType !== undefined ? data.crewType.crewTypeCode : null;
            search.crewBase = data.base !== null && data.base !== undefined ? data.base.airPortCode : null;
            search.status = data.status !== null && data.status !== undefined ? data.status.statusCode :null;
            search.crewId = data.crewId !== null && data.crewId !== undefined ? data.crewId :null;
            model.searchCriteria = search;
        };

        self.searchMissingSignInData = function(successFn, errorFn){
            RemoteService.searchMissingSignInData(model.searchCriteria).then(
                function (response) {
                    if(response.success && !!response.missingSignInData){
                    	var missingSignInList = MissingSignInFactory.formateMissingSignInData(response.missingSignInData);
                        successFn(missingSignInList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.doSignIn = function(data,successFn, errorFn){
        	 var signInRequest = MissingSignInFactory.populateSignInRequest(data);
        	 RemoteService.doSignIn(signInRequest).then(
                     function (response) {
                         if(response.success){
                             successFn(response);
                         }
                     },
                     function (error) {
                         errorFn(error.msg[0]);
                     }
               );
        }
        
        self.searchMissingSignOutData = function(successFn, errorFn){
            RemoteService.searchMissingSignOutData(model.searchCriteria).then(
                function (response) {
                    if(response.success && !!response.missingSignOutData){
                    	var missingSignOutList = MissingSignInFactory.formateMissingSignOutData(response.missingSignOutData);
                        successFn(missingSignOutList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.doSignOut = function(data,successFn, errorFn){
       	 var signOutRequest = MissingSignInFactory.populateSignOutRequest(data);
       	 RemoteService.doSignOut(signOutRequest).then(
                    function (response) {
                        if(response.success){
                            successFn(response);
                        }
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
              );
       }
        
       self.activateReport = function(data,successFn, errorFn){
          	 var reportActivateRequest = MissingSignInFactory.populateReportActivateRequest(data);
          	 RemoteService.activateReport(reportActivateRequest).then(
                       function (response) {
                           if(response.success){
                               successFn(response);
                           }
                       },
                       function (error) {
                           errorFn(error.msg[0]);
                       }
                 );
       }
       
       self.extendDeadline = function(data,successFn, errorFn){
        	 var extendDeadlineRequest = MissingSignInFactory.populateDeadlineExtendRequest(data);
        	 RemoteService.extendDeadline(extendDeadlineRequest).then(
                     function (response) {
                         if(response.success){
                             successFn(response);
                         }
                     },
                     function (error) {
                         errorFn(error.msg[0]);
                     }
               );
     }
        
        
               
    }
})();